/**
 * Created by vladislav on 25.02.2020
 */

const LanternMissionLogic = function (mission) {
    this.mission = mission;
    this.lantern = new Lantern(mission);
};

LanternMissionLogic.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    if (this.lantern && this.lantern.isActive(game.level) && this.lantern.savedStreak < Lantern.getMaxStreak()) {
        game.rewards.lantern = 1;
    }
};